import { createBorder } from './border';
import { createFocusRing } from './focusRing';
import { visuallyHidden } from './visuallyHidden';

import type { Theme, ThemeOptions } from '@mui/material';

interface CustomMixins {
  border: ReturnType<typeof createBorder>;
  focusRing: ReturnType<typeof createFocusRing>;
  visuallyHidden: typeof visuallyHidden;
}

declare module '@mui/material/styles/createMixins' {
  interface Mixins extends CustomMixins {}
  interface MixinsOptions extends CustomMixins {}
}

export const createMixins = (params: { theme: Omit<Theme, 'mixins'> }): ThemeOptions['mixins'] => {
  const { theme } = params;
  return {
    border: createBorder(theme),
    focusRing: createFocusRing(theme),
    visuallyHidden: visuallyHidden,
  };
};
